export default {
  baseStyle: {
    fontFamily: 'Open Sans'
  }
}
